import { useEffect, useState } from 'react';
import { Toast, ToastContainer, ProgressBar } from 'react-bootstrap';
export default (props) => {

    const { onOpen, onClose, title, text, type, delay } = props;

    const [time,setTime] = useState(100);

    const ENVIRONMENT_TYPE_TOAST = {
        success: "c-toast-header-success",
        danger: "c-toast-header-danger",
        warning: "c-toast-header-warning",
        info: "c-toast-header-info",
    }

    useEffect(() => {
        setTimeout(() => {
            setTime(time-1);
        },40)
    },[time])

    return (
        <ToastContainer position="top-end" className="brtx-toast">
            <Toast className="brtx-toast" onClose={() => onClose(false)} show={onOpen} delay={(!delay ? delay : 5000)} autohide>
                <Toast.Header className={ENVIRONMENT_TYPE_TOAST[type]}>
                    <strong className="me-auto">{title}</strong>
                </Toast.Header>
                <Toast.Body className="bg-white">
                    {text}
                </Toast.Body>
                <ProgressBar now={time} className="c-pb" variant="gray"/>
            </Toast>
        </ToastContainer >
    );
}